export const QUOTA_EXCEEDED = 'QUOTA_EXCEEDED';
export const REPEATED_RESPONSE = 'REPEATED_RESPONSE';
export const MAX_RESPONSES = 'MAX_RESPONSES';
export const ONLY_DESKTOP = 'ONLY_DESKTOP';
export const ONLY_MOBILE = 'ONLY_MOBILE';
export const DATA_QUALITY_ERROR = 'DATA_QUALITY_ERROR';
export const SURVEY_IS_PAUSED_AND_HAS_OVER_QUOTA_LINK = 'SURVEY_IS_PAUSED_AND_HAS_OVER_QUOTA_LINK';
export const SURVEY_NOT_AVAILABLE = 'SURVEY_NOT_AVAILABLE';
